import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: 'responsive',
  features: [],
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarShow(state, action) {
      state.sidebarShow = action.payload;
    },
    setFeatures(state, action){
      state.features = action.payload;
    }
  }
})

export const { setSidebarShow, setFeatures } = uiSlice.actions;
export default uiSlice.reducer;
